import { inputClassName } from "./Inputs";
import { useEffect, type ChangeEvent } from "react";
import { Form } from "@circle-react-shared/uikit/Form";
import { useFormContext } from "react-hook-form";

export const AllValuesInputField = ({
  name,
  selectedRadius,
}: {
  name: string;
  selectedRadius: string;
}) => {
  const { setValue, watch } = useFormContext();
  const value = watch(name);

  const handleAllChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setFieldValue(value);
  };

  const setFieldValue = (value: string) => {
    const newValues = {
      border_left_top_radius: value,
      border_left_bottom_radius: value,
      border_right_top_radius: value,
      border_right_bottom_radius: value,
    };
    setValue(name, newValues);
  };

  useEffect(() => {
    setValue(`${name}.border_radius`, value.border_left_top_radius);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only initialization
  }, []);

  return (
    <Form.Item
      isFirstChild
      hideBorder
      hideDescription
      hideLabel
      name={`${name}.border_radius`}
      className="!p-0"
    >
      <Form.Input
        label={null}
        name={`${name}.border_radius`}
        type="number"
        min={0}
        className={inputClassName}
        onChange={handleAllChange}
        disabled={selectedRadius !== "all"}
      />
    </Form.Item>
  );
};
